var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('modal',{key:_vm.layoutName,attrs:{"name":"modal-signup","width":620}},[_c(_vm.activeElem,{tag:"component"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }